export const isEmailIdentifier: (value?: string) => boolean = (value) => value?.includes("@") || false;

export const sanitizePhoneNumber: (phoneNumber: string) => string = (phoneNumber) => phoneNumber.replace(/[^0-9]/g, "");

export type PasswordValidationType = {
  check: (value: string) => boolean,
  message: string,
  shortMessage: string,
  field: "password"
}
export const passwordValidations = [
  {
    check: (password: string): boolean => password.length < 8,
    message: "Password must contain at least 8 characters.",
    shortMessage: "At least 8 characters",
    field: "password",
  },
  {
    check: (password: string): boolean => !password.match(/[0-9]/),
    message: "Password must contain at least one number.",
    shortMessage: "One number",
    field: "password",
  },
  {
    check: (password: string): boolean => !password.match(/[a-z]/),
    message: "Password must contain at least one lowercase letter.",
    shortMessage: "One lowercase letter",
    field: "password",
  },
  {
    check: (password: string): boolean => !password.match(/[A-Z]/),
    message: "Password must contain at least one uppercase letter.",
    shortMessage: "One uppercase letter",
    field: "password",
  },
] as PasswordValidationType[];

export const validatePassword = (password: string): PasswordValidationType[] =>
  passwordValidations.filter(({ check }) => check(password));

